import 'magnific-popup';

$(function () {
  $('.disconnect_line_confirm').click(function () {
    $.magnificPopup.open({
      items: { src: '#popup_disconnect_line' },
      type: 'inline',
      fixedContentPos: true
    }, 0);
  });

  // 確認ダイアログを閉じる
  $('.back').click(function () {
    $.magnificPopup.close()
  })

});